import path from '../../../assets/preisrechner/svg/path.svg'
import remove from '../../../assets/preisrechner/svg/delete.svg'
import select from '../../../assets/preisrechner/svg/select.svg'
import plus from '../../../assets/preisrechner/svg/plus.svg'
import minus from '../../../assets/preisrechner/svg/minus.svg'
import search from '../../../assets/preisrechner/svg/search.svg'


var map;
var myInfoWindow;
var myDrawingManager;
var setPerimeterData;

var state;

export function initializePerimeter(setData,storage) {
    state = storage();
    setPerimeterData = setData;
    map = new google.maps.Map(document.getElementById('map_div'), {
        center: {
            lat: 47.42358250311534,
            lng: 9.377961303262913
        },
        zoom: 18,
        disableDefaultUI: true,
        mapTypeId: 'satellite'
    });
    map.setTilt(0);
    // create a dialog box but dont bind it to anything yet    
    myInfoWindow = new google.maps.InfoWindow();

    // show drawing tools
    DrawingTools();
    if (state.value != null){
        document.getElementsByClassName("vermPerimeterArea")[0].innerHTML = state.value.value + "m²";
        const triangleCoords = state.coordinates.map(x => ({lat:x.latitude,lng:x.longitude}));
          // Construct the polygon.
          myField = new google.maps.Polygon({
            paths: triangleCoords,
            strokeColor: "#fb0a2a",
            fillColor: "#fb0a2a",
            fillOpacity: 0.2,
            draggable: true,
            editable: true,
            zIndex: 2000
          });

          myField.setMap(map);
          let bounds = new google.maps.LatLngBounds();
          myField.getPaths().forEach(function(path, index){

                  google.maps.event.addListener(path, 'insert_at', function(){
                    setPerimeterData(myField.getPath(),GetArea(myField));
                  });

                  google.maps.event.addListener(path, 'remove_at', function(){
                    setPerimeterData(myField.getPath(),GetArea(myField));
                  });

                  google.maps.event.addListener(path, 'set_at', function(){  
                    setPerimeterData(myField.getPath(),GetArea(myField));
                  });
                });
          myField.getPath().forEach(x => bounds.extend(x));
          map.setCenter(bounds.getCenter());
    }
}

function DrawingTools() {
    myDrawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: false,
        polygonOptions: {
            draggable: true,
            editable: true,
            fillColor: '#fb0a2a',
            fillOpacity: 0.2,
            strokeColor: '#fb0a2a',
            zIndex: 2000
        }
    });
    myDrawingManager.setMap(map);

    AddCustomSearchBar(map);

    DrawingCustomButton(map, path, CreateField);
    DrawingCustomButton(map, remove, DeleteField);
    DrawingCustomButton(map, select, DisableDrawing);

    DrawCustomZoomButtons();


    DrawingCompletionListener();
};

function DrawCustomZoomButtons() {
    var customControlDiv = document.createElement('div');
    customControlDiv.id = "zoom";

    var zoomIn = document.createElement('div');
    // Set CSS for the control interior
    var controlText = document.createElement('img');
    controlText.src = plus;
    zoomIn.appendChild(controlText);

    // Setup the click event listeners
    google.maps.event.addDomListener(zoomIn, 'click', function () {
        ZoomIn();
    });
    customControlDiv.appendChild(zoomIn);
    var zoomOut = document.createElement('div');
    // Set CSS for the control interior
    var controlText = document.createElement('img');
    controlText.src = minus;
    zoomOut.appendChild(controlText);

    // Setup the click event listeners
    google.maps.event.addDomListener(zoomOut, 'click', function () {
        ZoomOut();
    });
    customControlDiv.appendChild(zoomOut);

    customControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.TOP_CENTER].push(customControlDiv);
}

function AddCustomSearchBar(map) {
    var customControlDiv = document.createElement('div');
    customControlDiv.id = 'input_base';

    var input = document.createElement('input');
    input.placeholder = "Adresse";
    input.id = "perimeterInput";
    customControlDiv.appendChild(input);
    console.log('input');

    var controlText = document.createElement('img');
    controlText.src = search;
    customControlDiv.appendChild(controlText);

    customControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.TOP_CENTER].push(customControlDiv);

    var searchBox = new google.maps.places.SearchBox(input);

    google.maps.event.addListener(searchBox, 'places_changed', function () {
        var place = searchBox.getPlaces()[0];
        map.setCenter(place.geometry.location);
    });
}


function DrawingCustomButton(map, imagesrc, controlfunction) {
    // Create the DIV to hold the control and call the CustomControl() constructor passing in this DIV.
    var customControlDiv = document.createElement('div');
    var controlUI = document.createElement('div');
    controlUI.id = 'button_base';

    customControlDiv.appendChild(controlUI);

    // Set CSS for the control interior
    var controlText = document.createElement('img');
    controlText.src = imagesrc;
    controlUI.appendChild(controlText);

    // Setup the click event listeners
    google.maps.event.addDomListener(controlUI, 'click', function () {
        controlfunction();
    });

    customControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.TOP_CENTER].push(customControlDiv);

}

var myField = undefined;

// Draw polygones or polylines and add clicklistener to open infoWindow 
function DrawingCompletionListener() {
    // capture the field, set selector back to hand, remove drawing
    google.maps.event.addListener(
        myDrawingManager,
        'overlaycomplete',
        function (event) {
            if (event.type == google.maps.drawing.OverlayType.POLYGON) {
                myField = event.overlay;
                //ShowDrawingTools(false);
                DisableDrawing();
                
                console.log(myField.getPath());
                //console.log(google.maps.geometry.spherical.computeArea())
                setPerimeterData(myField.getPath(),GetArea(myField));
                //setPerimeterData(myField.getPath());  <<<< HOOK HIER
                //console.log(state);



                myField.getPaths().forEach(function(path, index){

                  google.maps.event.addListener(path, 'insert_at', function(){
                    setPerimeterData(myField.getPath(),GetArea(myField));
                  });

                  google.maps.event.addListener(path, 'remove_at', function(){
                    setPerimeterData(myField.getPath(),GetArea(myField));
                  });

                  google.maps.event.addListener(path, 'set_at', function(){  
                    setPerimeterData(myField.getPath(),GetArea(myField));
                  });

                });
            }
        }
    );
}


/**
 * Show or hide drawing tools
 */
function DisableDrawing() {
    myDrawingManager.setOptions({
        drawingMode: null
    });
}

function ShowDrawingTools(val) {
    myDrawingManager.setOptions({
        drawingControl: val
    });
}

/**
 * Delete the polygon / polyline and show the drawing tools again
 */
function DeleteField() {
    myInfoWindow.close();
    if (myField) {
        myField.setMap(null);
    }
    //ShowDrawingTools(true);
}

function CreateField() {
    DeleteField();
    myDrawingManager.setOptions({
        drawingMode: google.maps.drawing.OverlayType.POLYGON
    });
}

function ZoomIn() {
    map.setZoom(map.getZoom() + 1);
}

function ZoomOut() {
    map.setZoom(map.getZoom() - 1);
}

/**
 * Get area / perimeter / lenght of the drawn polygon / polyline
 */
function GetArea(obj) {
    var result = Math.round(parseFloat(google.maps.geometry.spherical.computeArea(obj.getPath())));
    document.getElementsByClassName("vermPerimeterArea")[0].innerHTML = result + "m²";
    console.log("AREA: "+result);
    return result;
}

function GetLength(obj) {
    var length = parseFloat(google.maps.geometry.spherical.computeLength(obj.getPath()));
    return length.toFixed(0);
}